import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 19"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M3.048 18.286a1.956 1.956 0 0 1-1.435-.597 1.956 1.956 0 0 1-.597-1.435V3.048H0V1.016h5.08V0h6.095v1.016h5.079v2.032h-1.016v13.206c0 .559-.199 1.037-.597 1.435a1.956 1.956 0 0 1-1.435.597H3.048ZM13.206 3.048H3.048v13.206h10.158V3.048ZM5.08 14.222h2.032V5.08H5.08v9.143Zm4.064 0h2.032V5.08H9.143v9.143Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };